// Module
var code = "<header> <flip-card></flip-card> <nav> <ul> <li><a href=\"/\">Home</a></li> <li><a href=\"/about.html\">About</a></li> <li><a href=\"/contact.html\">Contact</a></li> </ul> </nav> </header>";
// Exports
export default code;